import React from 'react'
import Quiz from 'components/quiz/Quiz/Quiz'
import { Terms } from 'components/quiz/Terms/Terms'
import { SentryErrorBoundary } from 'components/common/SentryErrorBoundary'
import { Translate } from 'utils/translate'
import { connect } from 'react-redux'
import { getLanguage, isAccessBlocked } from 'ducks/respondent'
import DeadlineExpired from 'components/quiz/DeadlineExpired/DeadlineExpired'
import AbilityWelcome from './components/GMA/AbilityWelcome/AbilityWelcome'
import AbilityExample from './components/GMA/AbilityExample/AbilityExample'
import AbilityQuestionPage from './components/GMA/AbilityQuestionPage/AbilityQuestionPage'
import PersonalityQuestionPage from './components/personality/PersonalityQuestionPage/PersonalityQuestionPage'
import InterestQuestionPage from './components/interest/InterestQuestionPage/InterestQuestionPage'

import { addResizeListener } from 'utils/screen'
import {
  getLocation,
  PERSONALITY_QUIZ,
  INTEREST_QUIZ,
  QUIZ_MAIN,
  QUIZ_TERMS,
  GMA_QUIZ,
  GMA_QUIZ_GUIDE,
  GMA_QUIZ_WELCOME,
} from 'ducks/router'

const CandidateApp = ({ type, language, expired }) => {
  React.useEffect(addResizeListener)
  const Page =
    expired && type !== QUIZ_TERMS
      ? DeadlineExpired
      : {
          [QUIZ_MAIN]: Quiz,
          [QUIZ_TERMS]: Terms,
          [GMA_QUIZ_WELCOME]: AbilityWelcome,
          [GMA_QUIZ_GUIDE]: AbilityExample,
          [GMA_QUIZ]: AbilityQuestionPage,
          [PERSONALITY_QUIZ]: PersonalityQuestionPage,
          [INTEREST_QUIZ]: InterestQuestionPage,
        }[type]
  return (
    <SentryErrorBoundary>
      <div className="MobileAppPage">
        <Translate language={language}>
          <Page />
        </Translate>
      </div>
    </SentryErrorBoundary>
  )
}

export default connect(state => ({
  type: getLocation(state).type,
  language: getLanguage(state),
  expired: isAccessBlocked(state),
}))(CandidateApp)
